import { TRetailerTags } from '@lib/core/retailers/types/retailerDetail';
import MixpanelTracker from '@lib/tools/dat/mixpanel';
import { localeWidget } from '@lib/tools/locale/source/web/widget';
import { VH_VARIANTS } from '@lib/tools/shared/helpers/consts';

import * as S from '@components/web/src/atoms/Banner/DiscountBanner/styles';
import Button from '@components/web/src/atoms/Buttons/Button';
import { Text } from '@components/web/src/foundations/Text/Text';
import { COLORS } from '@components/web/src/styles';

interface Props {
  discountCoupon: TRetailerTags['discountCoupon'];
}

export const DiscountBanner = ({ discountCoupon }: Props) => {
  const { copyText, discountTitleText } = localeWidget.discountBanner;
  const { code, value } = discountCoupon;

  const handleCopyDiscountId = async () => {
    if (!code) return;
    MixpanelTracker.events.discountCodeCopiedEvent({ discountCodePosition: 'Banner', discountCodeText: code });
    await navigator.clipboard.writeText(code);
  };

  return (
    <S.DiscountBannerWrapper isFullWidth align="center" gap={10} justify="space-between">
      <Text
        color={COLORS.base.white}
        localeOptions={{ value }}
        size="body2"
        text={discountTitleText}
        weight="semibold"
      />
      <Text
        color={COLORS.base.white}
        size="body2"
        style={{ textShadow: '0 0 8px rgba(0, 0, 0, 0.75)' }}
        text={code}
        weight="semibold"
      />
      <Button
        handleClick={handleCopyDiscountId}
        iconPosition="right"
        size="sm"
        style={{ cursor: 'copy' }}
        text={copyText}
        textColor={COLORS.base.white}
        textDecoration="underline"
        textWeight="medium"
        variant={VH_VARIANTS.LINK}
        icon={
          <svg fill="none" height="19" viewBox="0 0 19 19" width="19">
            <path
              d="M3.33502 11.6683H2.50169C2.05966 11.6683 1.63574 11.4927 1.32318 11.1801C1.01062 10.8676 0.835022 10.4437 0.835022 10.0016V2.50163C0.835022 2.0596 1.01062 1.63568 1.32318 1.32312C1.63574 1.01056 2.05966 0.834961 2.50169 0.834961H10.0017C10.4437 0.834961 10.8676 1.01056 11.1802 1.32312C11.4928 1.63568 11.6684 2.0596 11.6684 2.50163V3.33496M8.33502 6.66829H15.835C16.7555 6.66829 17.5017 7.41449 17.5017 8.33496V15.835C17.5017 16.7554 16.7555 17.5016 15.835 17.5016H8.33502C7.41455 17.5016 6.66836 16.7554 6.66836 15.835V8.33496C6.66836 7.41449 7.41455 6.66829 8.33502 6.66829Z"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.67"
            />
          </svg>
        }
      />
    </S.DiscountBannerWrapper>
  );
};
